import React from 'react';
import './notificationList.scss';
import NotificationStatusBadge from 'components/notificationStatusBadge';
import {
	ALL_MEMBERS_LABEL,
	AUDIENCE_TYPES,
} from 'helpers/notificationDelivery';

function NotificationsList({ notifications, openNotificationInfo, ...rest }) {
	const formatAudience = ({ audience, audience_type }) => {
		if (audience_type === AUDIENCE_TYPES.ALL) return ALL_MEMBERS_LABEL;

		// Extract names from audience objects (new format) or use strings directly (backward compatibility)
		const audienceNames = (audience || [])
			.filter(Boolean)
			.map((item) => (typeof item === 'string' ? item : item.name));

		// An empty audience no longer means "everyone"
		if (audienceNames.length === 0) return '—';

		const audienceLower = audienceNames.map((s) => s.toLowerCase());
		if (audienceLower.some((s) => s.includes('all users') || s === 'all users')) {
			return 'All Users';
		}
		const mapped = audienceNames.map((audienceName) => {
			const lower = audienceName.toLowerCase();
			if (lower.includes('elite')) return 'Elite';
			if (lower.includes('accés') || lower.includes('acces')) return 'Accés';
			if (lower.includes('noir')) return 'Noir';
			if (lower.includes('member') || lower.includes('all members'))
				return 'All Members';
			return audienceName;
		});

		// Format with comma and period after first item if it's Elite (as shown in image)
		if (mapped.length > 1 && mapped[0] === 'Elite') {
			return mapped
				.map((item, index) => {
					if (index === 0) return 'Elite,.';
					return item;
				})
				.join(' ');
		}

		return mapped.join(', ');
	};

	const formatSummary = ({ stats, total_recipients }) =>
		`${stats.delivered.toLocaleString()} delivered · ` +
		`${stats.failed.toLocaleString()} failed · ` +
		`${total_recipients.toLocaleString()} recipients`;

	return (
		<div className="NotificationsList" {...rest}>
			{notifications.map((notification) => (
				<div
					key={'notificationKey_' + notification.id}
					className="NotificationsList__item"
					onClick={() => openNotificationInfo(notification)}>
					<div className="NotificationsList__item--content">
						<div className="NotificationsList__item--main">
							<h4 className="NotificationsList__item--title">
								{notification.title}
							</h4>
							<p className="NotificationsList__item--message">
								{notification.message}
							</p>
						</div>
						<div className="NotificationsList__item--meta">
							<div className="NotificationsList__item--date">
								{notification.created_at}
							</div>
							<NotificationStatusBadge status={notification.status} />
							<div className="NotificationsList__item--audience">
								Audience: {formatAudience(notification)}
							</div>
							{notification.total_recipients > 0 && (
								<div className="NotificationsList__item--summary">
									{formatSummary(notification)}
								</div>
							)}
						</div>
					</div>
				</div>
			))}
			{notifications.length === 0 && (
				<div className="NotificationsList__noResults">
					No notifications for selected filters
				</div>
			)}
		</div>
	);
}

export default NotificationsList;
